// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__Da6fw","content":"LayoutSettings_content__cORNS"};